export const ACTION = {
   
    GET_CATEGORY: 'GET_CATEGORY',
    GET_SUBJECT:'GET_SUBJECT',
    CLEAR_SUBJECT:'CLEAR_SUBJECT',
    SEND_OTP:'SEND_OTP',
    GET_WRITE_TO_TOKEN:'GET_WRITE_TO_TOKEN',
    POST_WRITE_US:'POST_WRITE_US',
    
    
};


